var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_c('icon',{staticClass:"social-icon",class:'social-icon__' + _vm.site,attrs:{"icon-name":_vm.site,"view-box":"0 0 24 24"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }